import type { IconName } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import type { CrmEnrichmentJobType } from "../../../types/types";

import {
    StyledCrmEnrichmentJobTypeButton,
    StyledCrmEnrichmentJobTypeButtonDescription,
    StyledCrmEnrichmentJobTypeButtonIcon,
    StyledCrmEnrichmentJobTypeButtonTitle,
    StyledCrmEnrichmentJobTypeButtonIconWrapper,
} from "./styles";

type CrmEnrichmentJobTypeButtonProps = {
    isSelected: boolean;
    type: CrmEnrichmentJobType;
    title: string;
    description: string;
    iconName: IconName;
    onClick: (selectedType: CrmEnrichmentJobType) => void;
};

const CrmEnrichmentJobTypeButton = ({
    isSelected,
    type,
    title,
    description,
    iconName,
    onClick,
}: CrmEnrichmentJobTypeButtonProps) => (
    <StyledCrmEnrichmentJobTypeButton
        data-automation="job-type-button"
        data-automation-type={type}
        isSelected={isSelected}
        onClick={() => onClick(type)}
    >
        <StyledCrmEnrichmentJobTypeButtonIconWrapper>
            <StyledCrmEnrichmentJobTypeButtonIcon iconName={iconName} />
        </StyledCrmEnrichmentJobTypeButtonIconWrapper>

        <I18n
            translatable={{ key: title }}
            element={StyledCrmEnrichmentJobTypeButtonTitle}
        />
        <I18n
            translatable={{ key: description }}
            element={StyledCrmEnrichmentJobTypeButtonDescription}
        />
    </StyledCrmEnrichmentJobTypeButton>
);

export default CrmEnrichmentJobTypeButton;
